export const NETWORK_ERROR_PATTERNS = [
  /network\s*error/i, // "Network Error", "NetworkError", "network connection"
  /timeout/i, // All timeout variations
  /ERR_NETWORK/i, // Axios error code
  /ERR_CANCELED/i, // Axios cancel code
  /net::ERR_/i, // All Chrome net errors
  /ECONNRESET/i,
  /connection\s*reset/i,
  /ECONNABORTED/i,
  /ECONNREFUSED/i,
  /ETIMEDOUT/i,
  /ENOTFOUND/i,
  /request\s*aborted/i,
  /AbortError/i,
  /Failed to fetch/i, // Chrome/Edge fetch
  /Load failed/i, // Safari fetch
  /canceled/i, // Axios cancellation
  /offline/i, // Offline-related messages
  /internet connection/i, // Safari "Internet connection appears to be offline"
  /status code 499/i, // CloudFront client closed request
  /status code 504/i // Gateway timeout — infrastructure, not frontend bug
];

// Patterns too broad for axios error detection — they match application error
// messages (e.g., "Database query timeout", "Order was canceled").
// Timeouts are still detected via explicit error codes (ERR_TIMEOUT, ECONNABORTED).
const OVERLY_BROAD_SOURCES = new Set(["timeout", "canceled"]);

// Pre-filtered patterns safe for axios shouldReportError / isAxiosNetworkError.
export const AXIOS_NETWORK_PATTERNS = NETWORK_ERROR_PATTERNS.filter(
  pattern => !OVERLY_BROAD_SOURCES.has(pattern.source)
);
